import React from "react";
import { Helmet } from "react-helmet-async";

const Head = ({ Title, description, href }) => {
  return (
    <Helmet>
      <title>IT Ghar | IT Services Agency || {Title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={href} />
    </Helmet>
  );
};

export default Head;
